import React from 'react';

const Contact = ({ id }) => {
  return (
    <div id={id}>
      <section class='text-gray-800 bg-gray-900 body-font relative'>
        <div class='container px-5 py-10 md:py-20 mx-auto'>
          <div class='flex flex-col text-center w-full mb-12'>
            <h1 class='sm:text-3xl text-2xl font-bold title-font mb-4 text-white'>
              Contact Us
            </h1>
            <p class='lg:w-2/3 mx-auto leading-relaxed text-white'>
              To learn more, feel free to submit your inquiry.
            </p>
          </div>
          <div class='lg:w-1/2 md:w-2/3 mx-auto'>
            <div class='flex flex-wrap -m-2'>
              <div class='p-2 w-1/2'>
                <div class='relative'>
                  <label for='name' class='leading-7 text-sm text-white font-medium'>
                    Name
                  </label>
                  <input
                    type='text'
                    id='name'
                    name='name'
                    class='w-full bg-white-100 bg-opacity-40 rounded border border-blue-900 focus:border-indigo-500 focus:bg-whitw-900 focus:ring-2 focus:ring-indigo-900 text-black outline-none text-black py-1 px-3 leading-8 transition-colors duration-200 ease-in-out'
                  />
                </div>
              </div>
              <div class='p-2 w-1/2'>
                <div class='relative'>
                  <label for='email' class='leading-7 text-sm text-white font-medium'>
                    Email
                  </label>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    class='w-full bg-white-100 bg-opacity-40 rounded border border-blue-900 focus:border-indigo-500 focus:bg-black-900 focus:ring-2 focus:ring-indigo-900 text-black outline-none text-black py-1 px-3 leading-8 transition-colors duration-200 ease-in-out'
                  />
                </div>
              </div>
              <div class='p-2 w-full'>
                <div class='relative'>
                  <label for='message' class='leading-7 text-sm text-white font-medium'>
                    Message
                  </label>
                  <textarea
                    id='message'
                    name='message'
                    class='w-full bg-white-100 bg-opacity-40 rounded border border-blue-900 focus:border-indigo-500 focus:bg-white-900 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-black py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out'
                  ></textarea>
                </div>
              </div>
              <div class='p-2 w-full'>
                <button class='flex mx-auto text-blue-800 font-bold bg-white border-0 py-2 px-8 focus:outline-none hover:bg-indigo-400 rounded text-lg'>
                  Submit
                </button>
              </div>
              <div class='p-2 w-full pt-8 mt-8 border-t border-gray-800 text-center'>
                <a class='text-white font-bold'>nepbigyapan@gmail.com</a>
                <p class=' text-white font-light leading-normal my-5'>
                  Putalisadak, Kathmandu
                  <br />
                  9843817094
                </p>
                <span class='inline-flex'>
                  <a class='text-white'>
                    <svg
                      fill='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      class='w-5 h-5'
                      viewBox='0 0 24 24'
                    >
                      <path d='M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z'></path>
                    </svg>
                  </a>
                  <a class='ml-4 text-white'>
                    <svg
                      fill='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      class='w-5 h-5'
                      viewBox='0 0 24 24'
                    >
                      <path d='M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z'></path>
                    </svg>
                  </a>
                  <a class='ml-4 text-white'>
                    <svg
                      fill='none'
                      stroke='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      class='w-5 h-5'
                      viewBox='0 0 24 24'
                    >
                      <rect
                        width='20'
                        height='20'
                        x='2'
                        y='2'
                        rx='5'
                        ry='5'
                      ></rect>
                      <path d='M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01'></path>
                    </svg>
                  </a>
                  <a class='ml-4 text-white'>
                    <svg
                      fill='currentColor'
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      class='w-5 h-5'
                      viewBox='0 0 24 24'
                    >
                      <path d='M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z'></path>
                    </svg>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
